import React from 'react';
import PropTypes from 'prop-types';
import {
  TOLL_LIQUIDATION_DETAIL_BUTTON,
  TOLL_LIQUIDATION_DETAIL_DROPDOWN_OPTIONS,
} from '../../../../config/constants';
import DropdownButton from '../../../common/button/DropdownButton';

const PrintDetailDropdownButton = ({
  handleSubmit,
  onDownloadDetail,
  onDownloadProviaDetail,
}) => {
  const handleClick = (value) => {
    switch (value) {
      case TOLL_LIQUIDATION_DETAIL_BUTTON.DETAIL.value:
        handleSubmit(onDownloadDetail)();
        break;
      case TOLL_LIQUIDATION_DETAIL_BUTTON.PROVIA_DETAIL.value:
        handleSubmit(onDownloadProviaDetail)();
        break;
      default:
        break;
    }
  };

  return (
    <DropdownButton
      title="Descargar Detalle"
      color="secondary"
      options={TOLL_LIQUIDATION_DETAIL_DROPDOWN_OPTIONS}
      handleClick={handleClick}
    />
  );
};

PrintDetailDropdownButton.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onDownloadDetail: PropTypes.func.isRequired,
  onDownloadProviaDetail: PropTypes.func.isRequired,
};

export default PrintDetailDropdownButton;